<template>
    <v-app>
        <v-content>
            <v-container fluid>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-snackbar
                    v-model="snackbar"
                    :timeout="5000"                    
                    absolute
                    centered
                    shaped
                    top
                    >
                    Erro. Verifique sua conexão com a internet e tente novamente. Se o problema persistir entre em contato com o administrador do sistema
                </v-snackbar>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" lg="4" md="6" >
                        <v-card class="elevation-12">
                            <v-toolbar dark>
                            <v-toolbar-title>Login</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-text-field
                                        v-model="username"
                                        :label="$t('message.username')"
                                        name="login"
                                        prepend-icon="mdi-account"
                                        type="text"
                                        :rules="usernameRules"
                                    />

                                    <v-text-field
                                        v-model="password"
                                        id="password"
                                        :label="$t('message.password')"
                                        name="password"
                                        prepend-icon="mdi-lock"
                                        type="password"
                                        :rules="passwordRules"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn dark @click="login">Enviar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>

import router from '../router/index';
import i18n from '../i18n/messages';
import { AUTH_REQUEST } from '../store/actions/authentication';

export default {
	name:"Login",
    props: {
      source: String,
    },
    data: () => ({
        username: '',
        password: '',
        usernameRules: [
            v => !!v || i18n.t('message.login_validation_name')
        ],
        passwordRules: [
            v => !!v || i18n.t('message.login_validation_password')
        ],
        overlay: false,
        snackbar: false
    }),
    methods:{
        login (){
            if(this.$refs.form.validate()){
                const username = this.username;
                const password = this.password;
                this.overlay = true;
                this.$store.dispatch(AUTH_REQUEST, {username, password})
                    .then(()=>{               
                        this.overlay = false;      
                        router.go("/home");                        
                    })
                    .catch(()=>{             
                        this.snackbar = true;
                        this.overlay = false;                       
                });           
                          
            }
        }
    },
}
</script>
<style>
</style>